module.exports = {
	"amp": "&",
	"apos": "'",
	"gt": ">",
	"lt": "<",
	"quot": "\""
};


//////////////////
// WEBPACK FOOTER
// ./~/dom-serializer/~/entities/maps/xml.json
// module id = 349
// module chunks = 1 4 5 6 8 9 10 12 14 15 21 22 24 27 28 58